import type { EventProgram } from "../model/schemas";

export const eventProgramMock: EventProgram = {
  id: 1,
  title: "Программа зимнего фестиваля на курорте Мамисон 2023",
  sector: [
    {
      id: 1,
      sectorName: "Главная площадка",
      timeSlot: [
        {
          id: 1,
          time: "10:00 - 11:00",
          slotDetails: {
            id: 1,
            description: "Церемония открытия и приветственное слово",
            speaker: {
              id: 1,
              name: "Александр Иванов",
              position: "Директор курорта Мамисон",
              photo: {
                id: 1,
                url: "/images/preloader/1.jpg",
                alternativeText: "Александр Иванов",
              },
            },
          },
        },
        {
          id: 2,
          time: "11:30 - 12:30",
          slotDetails: {
            id: 2,
            description: "Выступление горнолыжной команды курорта",
            speaker: null,
          },
        },
        {
          id: 3,
          time: "13:00 - 14:00",
          slotDetails: {
            id: 3,
            description: "Обеденный перерыв",
            speaker: null,
          },
        },
      ],
    },
    {
      id: 2,
      sectorName: "Зона мастер-классов",
      timeSlot: [
        {
          id: 4,
          time: "10:30 - 11:30",
          slotDetails: {
            id: 4,
            description: "Мастер-класс по катанию для новичков",
            speaker: {
              id: 2,
              name: "Екатерина Петрова",
              position: "Инструктор по горным лыжам",
              photo: {
                id: 2,
                url: "/images/preloader/2.jpg",
                alternativeText: "Екатерина Петрова",
              },
            },
          },
        },
        {
          id: 5,
          time: "12:00 - 13:00",
          slotDetails: {
            id: 5,
            description: "Сноубординг для начинающих",
            speaker: {
              id: 3,
              name: "Дмитрий Смирнов",
              position: "Профессиональный сноубордист",
              photo: {
                id: 3,
                url: "/images/preloader/3.jpg",
                alternativeText: "Дмитрий Смирнов",
              },
            },
          },
        },
      ],
    },
    {
      id: 3,
      sectorName: "Детская зона",
      timeSlot: [
        {
          id: 6,
          time: "11:00 - 12:00",
          slotDetails: {
            id: 6,
            description: "Детские соревнования по снежным битвам",
            speaker: null,
          },
        },
      ],
    },
  ],
};
